/**
 * Application entry point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { configureAmplify } from './config/amplify.ts';
import './index.css';

// Configure AWS Amplify
configureAmplify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
